import Header from "./Header"
import "../Myprojects.css";
import React, { useState } from "react";
import api from "views/auth/Api";
// import "../../challenges/Challenges.css"
import Upload from "../../profile/components/Upload";
import { FileUploader } from 'react-drag-drop-files';
import { message } from 'antd';
import { API_BASE_URL } from '../../../../configs/AppConfig';


const fileTypes = ["pdf"];
const modelTypes = ["stl"];

const Submission = ({data, res}) => {
          const [pdf, setPdf] = useState(null);
          const [model, setModel] = useState(null);
          const [pdfLoading, setPdfLoading] = useState(false);
          const [modelLoading, setModelLoading] = useState(false);


        const successPdf = () => {
           message.success('Your PDF uploaded successfully');
          };
          const successModel = () => {
           message.success('Your STL uploaded successfully');
          };


      const success = () => {
           message.success('Your Submit Done successfully');
          };

    const handleChange = async (pdf) => {
       setPdfLoading(true);
          const formData = new FormData();
          formData.append('pdf', pdf);
           await api.post(`${API_BASE_URL}attachment/pdf`,formData, {
                      headers: {
            'Content-Type': 'multipart/form-data',
          }})
              .then(function (response) {
                setPdfLoading(false);
                        successPdf();
                        setPdf(response.data);
                          }).catch(error => {
                            console.log("handlesubmit error for blog get ", error)
                            });
  };

      const handleModel = async (model) => {
         setModelLoading(true);
          const formData = new FormData();
          formData.append('stl', model);
           await api.post(`${API_BASE_URL}attachment/stl`,formData, {
                      headers: {
            'Content-Type': 'multipart/form-data',
          }})
              .then(function (response) {
                setModelLoading(false);
                        successModel();
                        setModel(response.data);
                          }).catch(error => {
                            console.log("handlesubmit error for blog get ", error)
                            });
  };


    const handleSubmit = () => {
      submitForm();
        setPdf(null);
        setModel(null);
    }
      const submitForm = async () => {
      if(pdf || model)  await api.post(`${API_BASE_URL}projects-submission`,{
          presentation: pdf? pdf.id : null,
          model3d: model? model.id : null,
          teamId: data.id,
          projectId: data.project?.id
          })
        .then(function (response) {
                  console.log("handlesubmitffff  ", response.data)
                  success();
                  res(response.data);
        }).catch(error => {
          console.log("handlesubmit error for blog get ", error)
        });       
          }


  return (
        <div >
      {/* <Header /> */}
      <h2 className="h2Submission">Project Submission</h2>
       <div className="Submission-container">
        <div className="leftDev" >
          <div className="uploadBoxs">
            <div className="devParant">
              {/* <h4 className="uploadh4"> Presentation PDF </h4> */}
              {/* <div className="uploaddev">
              </div> */}
        <div className="uploaderSub">
          <FileUploader handleChange={handleChange} name="file" types={fileTypes}> 
          <Upload  title={pdf ? pdf.name : "Presentation PDF" } file={pdf} type="pdf" loading={pdfLoading} />
          </FileUploader>
          </div>

            </div>
            <div className="devParant">
              {/* <h4 className="uploadh4"> 3D Model </h4> */}
             {/* <div className="uploaddev">
              </div> */}
          <div className="uploaderSub">
          <FileUploader handleChange={handleModel} name="file" types={modelTypes}>
          <Upload title={model ? model.name : "3D Model" } file={model} type="stl" loading={modelLoading}/>
          </FileUploader>
          </div>
            </div>
          </div>
          {/* <div className="submitDev">
          <button className="submit">Submit</button>
          </div> */}
        </div>

          <div className="rightDev">
          <div className="submitDev">
          <button className="submit" onClick={handleSubmit}>Submit</button>
          </div>

            {/* <div className="teamsTop">
              <h2 className="rightH2">Team Members</h2>
              <div className="teamMembers">
                                {data.map((project,index) =>
            <div className="top4">
                <div className="animation-team"></div>
                <span>{project.userName}</span>
            </div>)}

              </div>
            </div>
            <div className="teamsBottom">
              <h2 className="rightH2">Recent Activity</h2>
              <div className="teamActivity"></div>
            </div> */}
          </div>

        </div>
    </div>
  );
};

export default Submission;
